import { useContext, useEffect, useRef, useState } from 'react';

//helpers
import { useClickAwayClose } from  '@/components/hooks/utility/useClickAwayClose';
import { ActivityFeedContext } from '@/context/ActivityFeedContext';
import { formatShortDateFilterContent } from  '@/helpers/ActivityFeed';
import { useHaltPropagation } from  '@/components/hooks/utility/useHaltPropagation';



const UseDateFilter = () => {
    const containerRef = useRef<any>()
    const scrollTargetRef = useRef<HTMLDivElement | null>(null);

    const {filterDates, setFilterDates} = useContext(ActivityFeedContext);
    const [showCalendar, setShowCalendar] = useState<boolean>(false);

    const title = "Date Range";
    const calendarButtonText = filterDates.length >= 1 ? formatShortDateFilterContent(filterDates) : "Latest";
    const calendarButtonAriaLabel = 'Filter the Activity Feed By Dates';
    const resetButtonText = 'Reset to latest';
    const resetButtonAriaLabel = 'Clear date selection';
    const resetIsDisabled = filterDates.length < 1;
    const className = showCalendar ? 'open' : '';
    const calendarSelectedDates = filterDates;

    useClickAwayClose(showCalendar, containerRef, () => setShowCalendar(false))

    useEffect(() => {
        if(filterDates.length === 2) {
            setTimeout(() => setShowCalendar(false), 500);
        }
    },[filterDates])

    useEffect(() => {
        if (showCalendar && scrollTargetRef.current) {
            scrollTargetRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }
    }, [showCalendar]);

    function onClickCalendarButton() {
        setShowCalendar(!showCalendar);
    }

    function onClickClearDates(e?: any) {
        useHaltPropagation(e);
        setFilterDates([]);
    }

    return {title, containerRef, calendarButtonText, calendarButtonAriaLabel, onClickCalendarButton, calendarSelectedDates, resetButtonText, resetButtonAriaLabel, onClickClearDates, resetIsDisabled, className, filterDates, setFilterDates, scrollTargetRef}
};
export default UseDateFilter